const DIRECT_VIDEO_EXT = /\.(mp4|webm|mov|m4v|ogv|ogg)(?:$|\?)/i
const IFRAME_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'

export { IFRAME_ALLOW }

export function isDirectVideoUrl(url?: string | null): boolean {
  if (!url) return false
  if (DIRECT_VIDEO_EXT.test(url)) return true

  try {
    const { hostname } = new URL(url)
    return /(?:^|\.)media\.tenor\.com$/i.test(hostname) || /(?:^|\.)media\d*\.giphy\.com$/i.test(hostname)
  } catch {
    return false
  }
}

export function getEmbedPlayerSrc(url?: string | null): string | null {
  if (!url || isDirectVideoUrl(url)) return null

  try {
    const parsed = new URL(url)
    const host = parsed.hostname.replace(/^www\./i, '').toLowerCase()

    if (host === 'youtu.be') {
      const id = parsed.pathname.split('/').filter(Boolean)[0]
      return id ? `https://www.youtube.com/embed/${id}` : null
    }

    if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'youtube-nocookie.com') {
      if (parsed.pathname.startsWith('/embed/')) return url
      const embedId = parsed.pathname.startsWith('/shorts/')
        ? parsed.pathname.split('/')[2]
        : parsed.searchParams.get('v')
      return embedId ? `https://www.youtube.com/embed/${embedId}` : null
    }

    if (host === 'player.vimeo.com') return url

    if (host === 'vimeo.com') {
      const id = parsed.pathname.split('/').filter(Boolean)[0]
      return id && /^\d+$/.test(id) ? `https://player.vimeo.com/video/${id}` : null
    }

    if (host === 'player.twitch.tv' || host === 'clips.twitch.tv') return url

    if (host === 'streamable.com') {
      const id = parsed.pathname.split('/').filter(Boolean)[0]
      if (!id || id === 'e') {
        return parsed.pathname.startsWith('/e/') ? url : null
      }
      return `https://streamable.com/e/${id}`
    }
  } catch {
    return null
  }

  return null
}

export function videoDimensions(width?: number | string | null, height?: number | string | null) {
  const w = Number(width)
  const h = Number(height)
  if (w > 0 && h > 0) return { width: w, height: h }
  return { width: 400, height: 225 }
}



// WEBPACK FOOTER //
// ./src/components/Markdown/render/mediaUrl.ts